import { Injectable } from '@angular/core';
import { ISourceSystemType } from '../../../foundation/models/enums/source-system-type.enum';
import { TabObject } from '../../components/tabs/tabs.model';
import { IRoute } from '../../models/iroute.interface';
import { RouteBuilderService } from './route-builder.service';

@Injectable()
/**
 * Builds transaction routes for finance
 */
export class FinanceRouteBuilderService extends RouteBuilderService {

    constructor() {
        super();
    }

    public get sourceSystemType(): ISourceSystemType {
        return this.sourceSystemTypes.Finance;
    }

    /**
     * Gets the route list for the transaction type provided.
     * @returns: Array of routes for transaction.
     */
    getRouteList(businessTransactionTypeId: number): any[] {
        const routeList: IRoute[] = [];

        switch (businessTransactionTypeId) {
            case 1065: {
                return this.getMiscellaneousPurchaseTabRoutes();
            }
            case 1111: {
                return this.getCountyMiscellaneousPurchaseTabRoutes();
            }
            case 56: {
                return this.getFundCustomerAccountRoutes();
            }
            case 1135: {
                return this.getTransferCustomerAccountTabRoutes();
            }
            case 1136: {
                return this.getMiscellaneousReversalTabRoutes();
            }
            default: {
                throw new Error('The business transaction type does not have its route list configured in the (area)-route-builder service');
            }
        }

        return routeList;
    }

    private getFundCustomerAccountRoutes(): TabObject[] {
        return [
            { name: 'fund-customer-account', title: 'Services', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false, helpContentUrl: '#CONTENT/Customer/Fund_Customer_Account.htm%3FTocPath%3DCustomer|_____4' }
        ];
    }

    private getCountyMiscellaneousPurchaseTabRoutes(): TabObject[] {

        return [
            { name: 'county-miscellaneous-purchase', title: 'Services', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMiscellaneousPurchaseTabRoutes(): TabObject[] {

        return [
            { name: 'miscellaneous-purchase', title: 'Services', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getTransferCustomerAccountTabRoutes(): TabObject[] {

        return [
            { name: 'transfer-customer-account', title: 'Services', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMiscellaneousReversalTabRoutes(): TabObject[] {

        return [
            { name: 'miscellaneous-reversal', title: 'Services', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

}
